import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AdminToolsProps {
  playerId: string;
}

const AdminTools: React.FC<AdminToolsProps> = ({ playerId }) => {
  const navigate = useNavigate();
  const isAdmin = Boolean(playerId && (playerId.endsWith('-legionears') || playerId.endsWith('-weegineers')));

  if (!isAdmin) return null;

  return (
    <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
      <button
        onClick={() => navigate('/admin')}
        style={{
          padding: '6px 14px',
          background: '#e91e63',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontWeight: 'bold'
        }}
      >
        Admin
      </button>
    </div>
  );
};

export default AdminTools;
